package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.InfoBoxIconStyle
import io.horion.cv.styles.InfoBoxStyle
import io.horion.cv.styles.InfoBoxTextStyle
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSUnitLengthOrPercentage
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun InfoBox(
    text: String,
    width: CSSNumericValue<out CSSUnitLengthOrPercentage>? = null,
    onClick: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val boxBorderColor = if (isDark) {
        Colors.border
    } else {
        Colors.Primary
    }

    val textColor = if (isDark) {
        Colors.White
    } else {
        Colors.Primary
    }

    Box(
        modifier = InfoBoxStyle
            .toModifier()
            .then(
                if (width != null) {
                    Modifier
                        .width(width)
                        .styleModifier {
                            property("max-width", "100%")
                            property("flex-shrink", "1")
                        }
                } else {
                    Modifier.styleModifier {
                        property("width", "fit-content")
                        property("max-width", "100%")
                        property("flex-shrink", "1")
                    }
                }
            )
            .border(
                1.px,
                LineStyle.Solid,
                boxBorderColor
            )
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier
                .fillMaxSize()
                .padding(left = 5.px, right = 10.px)
                .styleModifier {
                    property("min-width", "0")
                },
            verticalAlignment = Alignment.CenterVertically
        ) {
            Image(
                src = if (isDark) "/add-plus.svg" else "/plus.svg",
                description = "Icon plus",
                modifier = InfoBoxIconStyle.toModifier()
            )

            Box(
                modifier = Modifier.width(5.px)
            )

            SpanText(
                text = text,
                modifier = InfoBoxTextStyle
                    .toModifier()
                    .color(textColor)
                    .styleModifier {
                        property("min-width", "0")
                        property("overflow-wrap", "anywhere")
                    }
            )
        }
    }
}